<template>
  <div class="bg-white rounded-xl shadow-lg p-6 border-l-4 border-red-500">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-xl font-bold text-gray-900 flex items-center gap-2">
        <span>⚠️</span>
        Productos Críticos
      </h2>
      <div class="flex gap-2 text-xs">
        <span class="px-2 py-1 bg-red-100 text-red-800 rounded-full font-semibold">
          🔴 {{ productos.total_criticos }} Críticos
        </span>
        <span class="px-2 py-1 bg-orange-100 text-orange-800 rounded-full font-semibold">
          🟠 {{ productos.total_altos }} Altos
        </span>
        <span class="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full font-semibold">
          🟡 {{ productos.total_medios }} Medios
        </span>
      </div>
    </div>

    <div class="space-y-3 max-h-[600px] overflow-y-auto">
      <div
        v-for="producto in productos.detalle_productos"
        :key="producto.cotizacion_id"
        :class="getUrgenciaClass(producto.nivel_urgencia)"
        class="p-4 rounded-lg border-l-4 hover:shadow-md transition-all"
      >
        <!-- Header -->
        <div class="flex items-start justify-between mb-3">
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2 mb-1">
              <h4 class="font-semibold text-gray-900">{{ producto.folio }}</h4>
              <span :class="getUrgenciaBadgeClass(producto.nivel_urgencia)" class="px-2 py-0.5 rounded-full text-xs font-semibold">
                {{ producto.nivel_urgencia }}
              </span>
              <span class="px-2 py-0.5 bg-gray-100 text-gray-700 rounded-full text-xs font-medium">
                {{ getEstadoLabel(producto.estado_actual) }}
              </span>
            </div>
            <p class="text-sm font-medium text-gray-700">{{ producto.cliente }}</p>
            <p class="text-xs text-gray-500">{{ producto.vendedor }}</p>
          </div>
          <div class="text-right ml-3">
            <div class="text-2xl font-bold text-red-600">{{ producto.dias_transcurridos }}</div>
            <div class="text-xs text-gray-600">días</div>
          </div>
        </div>

        <!-- Producto Info -->
        <div class="bg-gray-50 rounded p-3 mb-3">
          <p class="text-sm font-medium text-gray-900 mb-1">{{ producto.producto }}</p>
          <p class="text-xs text-gray-600">Fecha venta: {{ formatearFecha(producto.fecha_venta) }}</p>
        </div>

        <!-- Progress Bar -->
        <div class="mb-2">
          <div class="flex justify-between items-center mb-1">
            <span class="text-xs text-gray-600">Progreso</span>
            <span class="text-xs font-semibold text-gray-900">{{ producto.porcentaje_avance.toFixed(1) }}%</span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-2">
            <div 
              :class="getProgressBarClass(producto.nivel_urgencia)"
              class="h-2 rounded-full transition-all duration-500"
              :style="`width: ${producto.porcentaje_avance}%`"
            ></div>
          </div>
        </div>

        <!-- Contact -->
        <div class="flex items-center justify-between text-xs">
          <span class="text-gray-600">📞 {{ producto.telefono }}</span>
          <button 
            v-if="producto.requiere_atencion"
            class="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition-colors font-medium"
          >
            ⚠️ Requiere Atención
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductosCriticos',
  props: {
    productos: {
      type: Object,
      required: true
    }
  },
  methods: {
    getUrgenciaClass(nivel) {
      switch (nivel) {
        case 'CRITICO':
          return 'bg-red-50 border-red-500';
        case 'ALTO':
          return 'bg-orange-50 border-orange-500';
        case 'MEDIO':
          return 'bg-yellow-50 border-yellow-500';
        case 'NORMAL':
          return 'bg-green-50 border-green-500';
        default:
          return 'bg-gray-50 border-gray-300';
      }
    },
    getUrgenciaBadgeClass(nivel) {
      switch (nivel) {
        case 'CRITICO':
          return 'bg-red-100 text-red-800';
        case 'ALTO':
          return 'bg-orange-100 text-orange-800';
        case 'MEDIO':
          return 'bg-yellow-100 text-yellow-800';
        case 'NORMAL':
          return 'bg-green-100 text-green-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    },
    getProgressBarClass(nivel) {
      switch (nivel) {
        case 'CRITICO':
          return 'bg-red-500';
        case 'ALTO':
          return 'bg-orange-500';
        case 'MEDIO':
          return 'bg-yellow-500';
        default:
          return 'bg-green-500';
      }
    },
    getEstadoLabel(estado) {
      const labels = {
        'SIN_FORMATO': 'Sin Formato',
        'FORMATO_IMPRESO': 'Formato Impreso',
        'FORMATO_APROBADO': 'Formato Aprobado',
        'EN_PRODUCCION': 'En Producción',
        'PRODUCCION_COMPLETA': 'Producción Completa'
      };
      return labels[estado] || estado;
    },
    formatearFecha(fecha) {
      const date = new Date(fecha + 'T00:00:00');
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  }
};
</script>
